// Angular
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { CommonModule, } from '@angular/common';

// Local library
import { FundingFacade, IAccountsACH } from '@amwager/funding/data-access';
import { CommonFacade, SessionService } from '@amwager/data-access';

import { AccountFacade } from '@amwager/account/data-access';
import {
  UnsubscribeObservableService
} from '@amwager/util';

// Third party
import { Observable, of, Subscription, takeUntil } from 'rxjs';
import { forEach } from 'lodash';

// Ionic
import { AlertController, IonCheckbox, IonIcon } from '@ionic/angular/standalone';

@Component({
  selector: 'feature-ion-online-check-withdraw',
  templateUrl: './online-check.component.html',
  styleUrls: ['./online-check.component.scss'],
  imports: [
    CommonModule,
    IonIcon,
    IonCheckbox,
    ReactiveFormsModule,
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OnlineCheckComponent extends UnsubscribeObservableService implements OnInit {

  onlineCheckForm!: FormGroup;
  // convenience getter for easy access to form fields.
  get formVal() { return this.onlineCheckForm?.controls }
  private subsWithdrawOnlineCheckResponse!: Subscription;
  private subsGetAccountResponse!: Subscription;
  private tmsId?: string;

  amount!: number;
  balance!: number;
  isProcessing = false;
  isAgree = false;
  accountId!: string;
  accounts$!: Observable<IAccountsACH[]>;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly sessionService: SessionService,
    private readonly fundingFacade: FundingFacade,
    private readonly accountFacade: AccountFacade,
    private readonly commonFacade: CommonFacade,
    private readonly alertCtrl: AlertController,
    private readonly elementRef: ElementRef,
    private readonly cdRef: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    this.observerTmsIds();
    this.initForm();
    this.amount;
    this.balance = 0;

    this.accountFacade.getBalance$().subscribe((balance) => {
      if (!balance) return;

      this.balance = balance;
      this.cdRef.markForCheck();
    });

    this.fundingFacade.getAchAccount();
    this.subsGetAccountResponse = this.fundingFacade.getAchAccountList$()
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe((response) => {

        if (response !== undefined)
          this.accounts$ = of(response);

        this.cdRef.markForCheck();
      });

  }

  private initForm(): void {
    this.onlineCheckForm = this.formBuilder.group({
      amount: ['', [Validators.required]]
    });
  }

  async showAlertMessage(header: string, message: string): Promise<void> {
    const alert = await this.alertCtrl.create({
      header,
      message: message,
      buttons: [
        {
          text: 'Close',
          role: 'cancel',
          handler: () => {
          }
        }
      ]
    });

    await alert.present();
  }

  withdrawAmount(): void {
    this.amount = this.formVal['amount']?.value;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  chooseAccount(account: string, accountId: any): void {

    const accountRows = this.elementRef.nativeElement.querySelectorAll(
      '.choose-account-list .row .selector'
    );
    accountRows.forEach((accountRow: HTMLElement) => {
      accountRow.classList.remove('active');
    });

    const accountRow = this.elementRef.nativeElement.querySelector(
      '.choose-account-list .row #' + account
    );

    // if (accountRow.classList.contains('selector')) {
      if (accountRow.classList.contains('active')) {
        accountRow.classList.remove('active');
        this.accountId = '';
      }
      else {
        accountRow.classList.add('active');
        this.accountId = accountId;
      }
    // }
  }

  withdraw(): void {
    if (!navigator.onLine) {
      this.commonFacade.setIsConnectedInternet('OnlineCheckComponent:withdraw', false);
      return;
    }

    if (this.onlineCheckForm.valid && this.amount && this.accountId && this.isAgree) {
      this.isProcessing = true;

      this.fundingFacade.withdrawOnlineCheck(
        this.amount,
        this.accountId,
        this.tmsId
      );
      this.subsWithdrawOnlineCheckResponse = this.fundingFacade.isWithdrawOnlineCheckSuccess$()
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe(({response, isSuccess}) => {
        if (!isSuccess && response !== undefined) {
          this.showAlertMessage('Withdraw Error', response.error.Message);
          this.isProcessing = false;
          this.cdRef.markForCheck();
        }

        this.subsWithdrawOnlineCheckResponse?.unsubscribe();

        if (isSuccess) {
          this.showAlertMessage(
            'Successful Withdrawal',
            'ACH Withdrawal successful, transaction will appear in your bank account within 1-3 business days.'
          );
          this.onlineCheckForm.reset();
          this.isAgree = false;
          this.isProcessing = false;
          this.cdRef.markForCheck();
        }
      });
    }
    else {
      this.markFormGroupTouched(this.onlineCheckForm);
    }
  }

  toggleCheckbox(): void {
    this.isAgree = !this.isAgree;
  }

  private observerTmsIds(): void {
    this.commonFacade?.tmsId$()
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe((tmsId: string | undefined) => {
        this.tmsId = tmsId;
      });
  }

  markFormGroupTouched(formGroup: FormGroup): void {
    forEach(formGroup.controls, (control) => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

}
